import { render, staticRenderFns } from "./BoosterButton.vue?vue&type=template&id=ca30c352"
import script from "./BoosterButton.vue?vue&type=script&lang=js"
export * from "./BoosterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports